
<div class="modal-body">
  <label translate>You are about to access fuctionality that might render your system inoperable.</label>
  <message class="danger">{{message}}</message>
</div>
<div class="modal-footer">
  <button class="btn btn-outline-danger" (click)="modal.close()" data-test-qa="confirm" translate>I understand</button>
  <button class="btn btn-outline-secondary" (click)="modal.dismiss()" data-test-qa="cancel" translate>Cancel</button>
</div>